import { render, staticRenderFns } from "./HTMLBoxReadOnly.vue?vue&type=template&id=adead6d4&"
import script from "./HTMLBoxReadOnly.vue?vue&type=script&lang=js&"
export * from "./HTMLBoxReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./HTMLBoxReadOnly.vue?vue&type=style&index=0&id=adead6d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports